import React, { Fragment } from 'react';
import { TableCell, TableRow, SvgIcon, IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';
import { DeleteIcon, EditIcon } from '../../Icons';
import ButtonIcon from '../IconButton';
import { getRowValue } from './cellRenderer';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  mySvgStyle: {
    height: '25px', //*[@id="Layer_1"]/g/path
    width: '25px',
    cursor: 'pointer',
    color: `${theme.palette.text.primary} !important`,
    '& [id="Layer_1"]': {
      fill: `${theme.palette.text.primary} !important`,
      '& [class*="st0"]': {
        fill: `${theme.palette.text.primary} !important`,
      },
    },
  },
}));
const Row = props => {
  const {
    row: { rawData, allowEdit, allowDelete, rowData },
    onDelete,
    onEdit,
    allowEditRow,
    allowDeleteRow,
    className,
    showMediaInPortal = false,
    displayImageInPortal,
  } = props;
  const classes = useStyles();
  const handleEdit = () => {
    onEdit(rawData);
  };

  const handleDelete = () => {
    onDelete(rawData);
  };
  const handleDisplayImageInPortal = () => {
    displayImageInPortal(rawData);
  };

  return (
    <TableRow className={className}>
      {Object.entries(rowData).map(([key, value]) => {
        return (
          <Fragment key={key}>
            <TableCell
              style={{ textAlign: '-webkit-center' }} //When we align using textAlign property,
              //align centers the text, -webkit-center will center the text and the image.
            >
              {getRowValue({
                data: value,
                showMediaInPortal,
                handleDisplayImageInPortal,
              })}
            </TableCell>
          </Fragment>
        );
      })}
      {(allowEditRow || allowDeleteRow) && (
        <TableCell>
          {allowEdit && (
            <ButtonIcon onClick={handleEdit} component={EditIcon} text="Edit" />
          )}
          {allowDelete && (
            <IconButton
              color="secondary"
              component="div"
              onClick={handleDelete}
              title={'Delete'}
            >
              <SvgIcon className={classes.mySvgStyle}>
                <DeleteIcon />
              </SvgIcon>
            </IconButton>
          )}
        </TableCell>
      )}
    </TableRow>
  );
};

Row.propTypes = {
  row: PropTypes.object,
  collapisble: PropTypes.bool,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  allowEditRow: PropTypes.bool,
  allowDeleteRow: PropTypes.bool,
  subTable: PropTypes.object,
  className: PropTypes.string,
  showMediaInPortal: PropTypes.bool,
  displayImageInPortal: PropTypes.func,
};

export default Row;
